import React from 'react';
import Select from '../../audi-ui-components/Select';
import _find from 'lodash/find';

const ModelFields = (props) => {
    const theme = props.theme || DEFAULT_THEME;
    const auiTheme = (theme === "dark" ? "light" : null);
    return (
      <>
        <div className="row">
            <div className="col-12 col-medium-6">
                <Select name="tradeMakeCode"
                    value={props.values["tradeMakeCode"]}
                    label="Make *"
                    options={props.rbMakes}
                    onChange={(v) => {
                        props.setFieldValue("tradeMakeCode", v);
                        props.rbGetFamilies(v);
                        props.setFieldValue("tradeFamilyCode", "");
                        props.setFieldValue("tradeModel", "");
                        props.setFieldValue("tradeYear", "");
                        let opt = _find(props.rbMakes, {value: v});
                        props.setFieldValue("tradeMake", opt.label);
                        props.clearRbData();
                    }}
                    isInvalid={props.errors["tradeMakeCode"] && props.touched["tradeMakeCode"]}
                    invalidMessage={props.errors["tradeMakeCode"]}
                    theme={auiTheme}
                />
            </div>
            <div className="col-12 col-medium-6">
                <Select name="tradeFamilyCode"
                    value={props.values["tradeFamilyCode"]}
                    label="Model *"
                    options={props.famOpts}
                    onChange={(v) => {
                        props.setFieldValue("tradeFamilyCode", v);
                        props.setFieldValue("tradeYear", "");
                        let opt = _find(props.famOpts, {value: v});
                        props.setFieldValue("tradeModel", opt.label);
                        props.selectFamily(v);
                        props.clearRbData();
                    }}
                    isInvalid={props.errors["tradeFamilyCode"] && props.touched["tradeFamilyCode"]}
                    invalidMessage={props.errors["tradeFamilyCode"]}
                    theme={auiTheme}
                />
            </div>
        </div>
        <div className="">
            <Select name="tradeYear"
                value={props.values["tradeYear"]}
                label="Year *"
                options={props.yearOpts}
                onChange={(v) => {
                    props.setFieldValue("tradeYear", v)
                    props.clearRbData();
                }}
                onBlur={() => { props.setFieldTouched("tradeYear"); }}
                isInvalid={props.errors["tradeYear"] && props.touched["tradeYear"]}
                invalidMessage={props.errors["tradeYear"]}
                theme={auiTheme}
            />
        </div>
      </>
    );
}

export default ModelFields;
